import { useFieldArray, useFormContext } from 'react-hook-form';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import reduce from 'lodash/reduce';

import { InputForm } from '@/components/form/Input';
import { InputNumberForm } from '@/components/form/InputNumber';

interface IConsumersComponent {
  type: string;
}

export const ConsumersComponent: React.FC<IConsumersComponent> = ({ type }) => {
  const { control, reset, setValue, getValues, watch } = useFormContext();

  const { fields, remove, insert } = useFieldArray({
    control,
    name: type,
  });

  const handleChange = () => {
    const data = getValues()[type];
    const checkEmptyData = data?.filter(
      (el: any) => !el?.consumer_count || !el?.flow_per_consumer
    );
    if (checkEmptyData?.length) {
      setValue(
        type === 'inflow_consumers' ? 'flow_inflow' : 'flow_exhaust',
        null
      );
      setValue('people_count', null);
    } else {
      const resultData = reduce(
        data,
        (a: any, b: any) => {
          return a + b?.consumer_count * b?.flow_per_consumer;
        },
        0
      );
      setValue(
        type === 'inflow_consumers' ? 'flow_inflow' : 'flow_exhaust',
        Math.ceil(resultData / 5) * 5
      );
      const sumPeople = reduce(
        data,
        (a: any, b: any) => {
          return a + b?.consumer_count;
        },
        0
      );
      type === 'inflow_consumers' && setValue('people_count', sumPeople);
    }
  };

  const handleAddRow = (index: number) => {
    const nullValuesObject: Record<string, null> = {
      consumer_count: null,
      flow_per_consumer: null,
    };

    insert(index + 1, nullValuesObject);
  };

  const handleRemoveRow = (ind: number) => {
    remove(ind);
  };

  return (
    <>
      <div className='flex flex-col gap-2'>
        {fields?.map((el, index) => (
          <div
            key={el?.id}
            className='flex gap-2 items-end w-full'
            onFocus={handleChange}
            onClick={handleChange}
            onKeyUp={handleChange}
          >
            <InputNumberForm
              size='middle'
              name={`${type}[${index}].consumer_count`}
              label={
                type === 'inflow_consumers'
                  ? 'Количество людей'
                  : 'Количество потребителей'
              }
              addonBefore={<i>N₁ =</i>}
              addonAfter={<i>{type === 'inflow_consumers' ? 'чел' : 'шт'}</i>}
              fixValue={0}
            />
            <InputNumberForm
              size='middle'
              name={`${type}[${index}].flow_per_consumer`}
              label='Расход на 1 потребителя'
              addonBefore={<i>L₁ =</i>}
              addonAfter={<i>м³/час</i>}
              fixValue={2}
            />
            <div className='flex gap-1'>
              <Button
                icon={<PlusOutlined />}
                onClick={() => handleAddRow(index)}
              ></Button>
              <Button
                disabled={fields?.length === 1}
                icon={<DeleteOutlined />}
                onClick={() => handleRemoveRow(index)}
              ></Button>
            </div>
          </div>
        ))}
        <InputForm
          disabled
          name={type === 'inflow_consumers' ? 'flow_inflow' : 'flow_exhaust'}
          label='Итоговый расход воздуха'
          addonBefore={<i>L₁ =</i>}
          addonAfter={<i>м³/час</i>}
        />
      </div>
    </>
  );
};
